export default __webpack_public_path__ + "static/media/restaurante.cb3a79ae.svg";